"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _upload = _interopRequireDefault(require("@/components/upload"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'feedbackEdit',
  components: {
    upload: _upload.default
  },
  data: function data() {
    return {
      issueArr: [{
        type: 1,
        name: '订单问题'
      }, {
        type: 2,
        name: '系统bug'
      }, {
        type: 3,
        name: '其他问题'
      }],
      form: {
        img_url: [],
        type: 1
      },
      fileList: []
    };
  },
  mounted: function mounted() {
    this.form.mobile = window.agentInfo.phone;
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;
      var params = JSON.parse(JSON.stringify(this.form));
      this.$post('commonapi/feedback/add', params).then(function (res) {
        _this.$message({
          message: '提交成功',
          type: 'success'
        });
        history.go(-1);
      });
    },
    /**
     * 上传文件成功通知
     */
    fileOk: function fileOk(arr) {
      this.form.img_url = arr;
    }
  }
};